import '../dropdown';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
  <ems-dropdown class="mr-3 mb-3 full-width">
    <button type="button" slot="dropdown-toggle" class="btn btn-outline-light">
      ${ctx.currentProductLabel}
      <span class="ai ai-chevron-down"></span>
    </button>
    <div slot="dropdown-menu" class="dropdown-menu m-0 w-100">
      ${ctx.productOptions.map((item, itemIndex) => html`
        <button type="button" class="btn dropdown-item ${item.value === ctx.product? 'active': ''}" @click="${(e) => ctx.selectOption('aofl_product', itemIndex)}">${item.label}</button>
      `)}
    </div>
  </ems-dropdown>

${ctx.showLicenses ? html`
<ems-dropdown class="mr-3 mb-3 full-width">
  <button type="button" slot="dropdown-toggle" class="btn btn-outline-light">
    ${ctx.currentLicenseLabel}
    <span class="ai ai-chevron-down"></span>
  </button>
  <div slot="dropdown-menu" class="dropdown-menu m-0 w-100">
    ${ctx.licenseOptions.map((item, itemIndex) => html`
      <button type="button" class="btn dropdown-item ${item.value === ctx.license? 'active': ''}" @click="${(e) => ctx.selectOption('license_id', itemIndex)}">${item.label}</button>
    `)}
  </div>
</ems-dropdown>`: ''}


<ems-dropdown class="mr-3 mb-3 full-width">
  <button type="button" slot="dropdown-toggle" class="btn btn-outline-light">
    ${ctx.currentLicenseStatusLabel}
    <span class="ai ai-chevron-down"></span>
  </button>
  <div slot="dropdown-menu" class="dropdown-menu m-0 w-100">
    ${ctx.licenseStatuses.map((item, itemIndex) => html`
      <button type="button" class="btn dropdown-item ${item.value === ctx.licenseStatus? 'active': ''} ${item.value === '' && ctx.product ? 'disabled': ''}" @click="${(e) => ctx.selectOption('license_status', itemIndex)}">${item.label}</button>
    `)}
  </div>
</ems-dropdown>

`;
